import { render } from "./DataDashboard.vue?vue&type=template&id=70164812&scoped=true"
import script from "./DataDashboard.vue?vue&type=script&lang=js"
export * from "./DataDashboard.vue?vue&type=script&lang=js"

import "./DataDashboard.vue?vue&type=style&index=0&id=70164812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70164812"]])

export default __exports__